import { Link, useNavigate } from "react-router-dom";

import { Space, Breadcrumb, Card } from "antd";
import { PageHeader } from "@ant-design/pro-layout";

import {
  DeviceProfileVendor,
  UpdateDeviceProfileVendorRequest,
} from "@chirpstack/chirpstack-api-grpc-web/api/device_profile_pb";

import VendorForm from "./VendorForm";
import deviceProfileStore from "../../stores/DeviceProfileStore";
import { useTitle } from "../helpers";

interface IProps {
  vendor: DeviceProfileVendor;
}

function EditVendor(props: IProps) {
  useTitle("Network Server", "Device Profiles", "Vendors", props.vendor.getName(), "Edit");
  const navigate = useNavigate();

  const onFinish = (vendor: DeviceProfileVendor) => {
    vendor.setId(props.vendor.getId());
    const req = new UpdateDeviceProfileVendorRequest();
    req.setVendor(vendor);

    deviceProfileStore.updateVendor(req, () => {
      navigate(`/device-profiles/vendors/${props.vendor.getId()}/devices`);
    });
  };

  return (
    <Space orientation="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb
            items={[
              { title: "Network Server" },
              { title: "Device Profiles" },
              { title: <Link to="/device-profiles/vendors">Vendors</Link> },
              {
                title: (
                  <Link to={`/device-profiles/vendors/${props.vendor.getId()}/devices`}>{props.vendor.getName()}</Link>
                ),
              },
              { title: "Edit" },
            ]}
          />
        )}
        title={`Edit ${props.vendor.getName()}`}
      />
      <Card>
        <VendorForm initialValues={props.vendor} onFinish={onFinish} />
      </Card>
    </Space>
  );
}

export default EditVendor;
